import React from 'react';
export const AnnouncementBar = () => {
  return <div className="w-full bg-medium h-[44px] flex items-center justify-center px-4" data-id="element-10">
      <p className="font-lato font-bold text-[14px] text-white tracking-[0.1em] text-center" data-id="element-11">
        LIMITED LAUNCH PRICE: Complete bundle available at $27 — Price increases
        to $47 soon
      </p>
    </div>;
};